import React, { useState } from 'react';
import './ResetPassword.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const token = window.RESET_TOKEN;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    try {
      const res = await fetch('https://kodez.robokalam.in/api/reset-password.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });

      const data = await res.json();
      setMessage(data.message);

      if (data.status === 'success') {
        setSuccess(true);
        setPassword('');
        setConfirm('');
      }
    } catch {
      setMessage("❌ Server error. Try again.");
    }
  };

  return (
    <div className="reset-wrapper">
      <div className="reset-header">
        <img src="/footer/rklogo.png" alt="Robokalam Logo" className="reset-logo" />
        <h1>Secure Your Account</h1>
        <p className="reset-subtext">Reset your password below to continue using KodeZ securely</p>
      </div>

      <div className="reset-box">
        <h2>Reset Your Password</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-with-icon">
            <input
              type={showPass ? 'text' : 'password'}
              placeholder="New Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              disabled={success}
            />
            <i
              className={`fa ${showPass ? 'fa-eye-slash' : 'fa-eye'} password-toggle`}
              onClick={() => setShowPass(!showPass)}
            />
          </div>

          <div className="input-with-icon">
            <input
              type={showConfirm ? 'text' : 'password'}
              placeholder="Confirm Password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              disabled={success}
            />
            <i
              className={`fa ${showConfirm ? 'fa-eye-slash' : 'fa-eye'} password-toggle`}
              onClick={() => setShowConfirm(!showConfirm)}
            />
          </div>

          {!success && (
            <button type="submit" className="reset-btn">Reset Password</button>
          )}
        </form>

        {message && (
          <p className="reset-msg" style={{ color: success ? 'green' : 'red' }}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
